import type { PPProviderBehavior } from '../types';

export const grantStreetBehavior: PPProviderBehavior = {
	label: 'Grant Street',
	cardDeviceDisplayName: 'EMV device',
	requiresPrepareTransaction: true,
	requiresPayorInformation: true,
	cardPrepareAutoStart: false,
	buildPrepareCheckRequest(ctx) {
		return {
			accountsToPay: ctx.cartItems.map((item) => ({
				accountNumber: item.item.itemNumber,
				amount: item.amountToPay,
			})),
			paymentType: 'ECHECK',
			location: ctx.kioskLocation,
			totalAmount: ctx.cartTotalAmount,
			payorInfo: ctx.payorInformation,
		};
	},
	buildPrepareCardRequest(ctx) {
		return {
			accountsToPay: ctx.cartItems.map((item) => ({
				accountNumber: item.item.itemNumber,
				amount: item.amountToPay,
			})),
			paymentType: 'CREDIT',
			location: ctx.kioskLocation,
			totalAmount: ctx.cartTotalAmount,
			payorInfo: ctx.payorInformation,
		};
	},
	getReceiptInvoiceNumber(item, cartId, obscure) {
		if (cartId) return cartId;
		return obscure ? (item.obscuredItemNumber ?? item.itemNumber) : item.itemNumber;
	},
	getTestPanelConfig() {
		return { show: true, altText: 'Grant Street' };
	},
};
